import React from 'react';
import {Button as BootstrapButton} from 'react-bootstrap';
import {css} from 'aphrodite';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/fontawesome-pro-solid';
import {generatePdfData, usePdfExport} from '../../../hooks/usePdfExport';

/**
 * Renders a button
 * @param {Object} button - The button object
 * @param {Object} data - The data object
 * @param {Object} styleSheet - The style sheet object
 * @param {Object} buttonStyle - The button style object
 * @returns {JSX.Element} The rendered button
 */
export const PdfLinkButton = ({button, data, styleSheet, buttonStyle}) => {
  const exportPdfData = data.map((row) => generatePdfData(row));

  // Using the usePdfExport hook to generate the PDF
  const {isGenerating, handlePdfExport} = usePdfExport({
    templateId: button.meta.templateId,
    templateName: button.meta.templateName,
    data: {data: exportPdfData},
    namePrefix: 'pdf-link'
  });

  return (
    <BootstrapButton disabled={isGenerating} className={css(styleSheet.buttonPrimary, buttonStyle)} onClick={handlePdfExport}>
      {isGenerating ? <FontAwesomeIcon icon={faSpinner} spin size="lg" /> : button.label}
    </BootstrapButton>
  );

};